export * from './app-header.component';



// WEBPACK FOOTER //
// /Users/elliot/code/abc-angular/src/app/components/app-header/index.ts